import { render, staticRenderFns } from "./CampagnaOperatoriList.vue?vue&type=template&id=12ad8b22&"
import script from "./CampagnaOperatoriList.vue?vue&type=script&lang=ts&"
export * from "./CampagnaOperatoriList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports